(function () {
  if (window.GiftWrapInitialized) return;
  window.GiftWrapInitialized = true;

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getDrawerRoot() {
    return document.querySelector('#CartDrawer');
  }

  function getGiftWrapContainer() {
    const drawerRoot = getDrawerRoot();
    if (!drawerRoot) return null;
    return drawerRoot.querySelector('#is-a-gift');
  }

  function getGiftWrapElements() {
    const container = getGiftWrapContainer();

    return {
      container,
      checkbox: container ? container.querySelector('#gift-wrapping') : null,
      noteField: container ? container.querySelector('#gift-note') : null,
      noteWrapper: container ? container.querySelector('#gift-note-wrapper') : null
    };
  }

  function getGiftWrapVariantId() {
    const container = getGiftWrapContainer();
    if (!container) return null;
    return container.dataset.giftWrapVariantId;
  }

  function updateNoteVisibility() {
    const elements = getGiftWrapElements();
    if (!elements.checkbox || !elements.noteWrapper) return;
    elements.noteWrapper.style.display = elements.checkbox.checked ? 'block' : 'none';
  }

  function setLoadingState(isLoading) {
    const elements = getGiftWrapElements();
    if (!elements.container) return;

    elements.container.style.pointerEvents = isLoading ? 'none' : '';
    elements.container.style.opacity = isLoading ? '0.6' : '';
  }

  function renderDrawerFromParsedState(parsedState) {
    const cartDrawer = getCartDrawer();

    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState.sections) {
      cartDrawer.renderContents(parsedState);
    } else {
      console.error('renderContents not available', parsedState);
      return;
    }
  }

  function cartUpdate(bodyData) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        ...bodyData,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    });
  }

  function setGiftWrap() {
    const variantId = getGiftWrapVariantId();
    if (!variantId) return;

    setLoadingState(true);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function () {
        return cartUpdate({
          attributes: {
            'gift-wrapping': 'yes'
          }
        });
      })
      .then(function (parsedState) {
        console.log('Gift wrap set response:', parsedState);
        renderDrawerFromParsedState(parsedState);
      })
      .catch(function (error) {
        console.error('Gift wrap set error:', error);
      })
      .finally(function () {
        setLoadingState(false);
      });
  }

  function removeGiftWrap() {
    const variantId = getGiftWrapVariantId();
    if (!variantId) return;

    setLoadingState(true);

    cartUpdate({
      updates: { [variantId]: 0 },
      attributes: {
        'gift-wrapping': '',
        'gift-note': ''
      }
    })
      .then(function (parsedState) {
        console.log('Gift wrap remove response:', parsedState);
        renderDrawerFromParsedState(parsedState);
      })
      .catch(function (error) {
        console.error('Gift wrap remove error:', error);
      })
      .finally(function () {
        setLoadingState(false);
      });
  }

  function saveGiftNote(noteText) {
    cartUpdate({
      note: noteText ? 'Geschenk-Nachricht: ' + noteText : '',
      attributes: {
        'gift-note': noteText
      }
    })
      .then(function (parsedState) {
        console.log('Gift note response:', parsedState);
        renderDrawerFromParsedState(parsedState);
      })
      .catch(function (error) {
        console.error('Gift note error:', error);
      });
  }

  function clearGiftWrapAttributes() {
    const elements = getGiftWrapElements();

    if (elements.checkbox) {
      elements.checkbox.checked = false;
    }

    if (elements.noteField) {
      elements.noteField.value = '';
    }

    if (elements.noteWrapper) {
      elements.noteWrapper.style.display = 'none';
    }

    return cartUpdate({
      attributes: {
        'gift-wrapping': '',
        'gift-note': ''
      }
    })
      .then(function (parsedState) {
        console.log('Gift wrap attributes cleared:', parsedState);
        renderDrawerFromParsedState(parsedState);
      })
      .catch(function (error) {
        console.error('Gift wrap attribute clear error:', error);
      });
  }

  function bindGiftWrapRemoveButton() {
    const drawerRoot = getDrawerRoot();
    const giftWrapVariantId = String(getGiftWrapVariantId());

    if (!drawerRoot || !giftWrapVariantId) return;

    const removeButtons = drawerRoot.querySelectorAll('cart-remove-button button');

    removeButtons.forEach(function (button) {
      const cartItem = button.closest('.cart-item');
      if (!cartItem) return;

      const clickedVariantId = String(cartItem.dataset.variantId || '');
      const isGiftWrapButton = clickedVariantId === giftWrapVariantId;

      if (!isGiftWrapButton) return;
      if (button.dataset.giftwrapRemoveBound) return;

      button.dataset.giftwrapRemoveBound = 'true';

      button.addEventListener('click', function () {
        setTimeout(function () {
          clearGiftWrapAttributes();
        }, 400);
      });
    });
  }

  function bindGiftWrap() {
    const elements = getGiftWrapElements();
    if (!elements.container) return;

    if (elements.checkbox && !elements.checkbox.dataset.giftwrapBound) {
      elements.checkbox.dataset.giftwrapBound = 'true';

      elements.checkbox.addEventListener('change', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        if (event.target.checked) {
          setGiftWrap();
        } else {
          removeGiftWrap();
        }
      });
    }

    if (elements.noteField && !elements.noteField.dataset.giftnoteBound) {
      elements.noteField.dataset.giftnoteBound = 'true';

      elements.noteField.addEventListener('change', function (event) {
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        saveGiftNote(event.target.value);
      });
    }

    updateNoteVisibility();
    bindGiftWrapRemoveButton();
  }

  function patchCartDrawerRender() {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer || cartDrawer.dataset.giftwrapPatched) return;
    if (typeof cartDrawer.renderContents !== 'function') return;

    cartDrawer.dataset.giftwrapPatched = 'true';

    const originalRenderContents = cartDrawer.renderContents.bind(cartDrawer);

    cartDrawer.renderContents = function (parsedState) {
      originalRenderContents(parsedState);

      setTimeout(function () {
        bindGiftWrap();
      }, 0);
    };
  }

  function initGiftWrap() {
    patchCartDrawerRender();
    bindGiftWrap();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGiftWrap();
  });

  document.addEventListener('shopify:section:load', function () {
    initGiftWrap();
  });
})();